import { useEffect, useState } from "react"
import { View } from "../../state/listing/generic-listing"
import PaymentTermService from "../../state/payment-term/PaymentTermService"
import { COLUMNS_WITH_PAYMENT_TERM_IDS, doesViewIncludeIds } from "../listing/generic-listing/utils"
import { SelectOption } from "../types"

export const useFetchPaymentTerms = (view: View, controller: AbortController) => {
    const [paymentTermOptions, setPaymentTermOptions] = useState<SelectOption<string>[]>()
    const [loadingPaymentTermOptions, setLoadingPaymentTermOptions] = useState<boolean>(false)

    useEffect(() => {
        const shouldFetchPaymentTerms = view && !paymentTermOptions && doesViewIncludeIds(view, COLUMNS_WITH_PAYMENT_TERM_IDS)

        if (shouldFetchPaymentTerms) {
            setLoadingPaymentTermOptions(true)

            new Promise<SelectOption<string>[]>((resolve, reject) => {
                PaymentTermService.getLabelsAsSelectOptions().then(resolve)
                controller.signal.addEventListener("abort", () => reject(new Error("payment terms request aborted")))
            }).then(paymentTermOptions => {
                setPaymentTermOptions(paymentTermOptions)
                setLoadingPaymentTermOptions(false)
            }).catch(err => console.warn(err))
        }
    }, [view])

    return {
        paymentTermOptions,
        loadingPaymentTermOptions,
    }
}


// WEBPACK FOOTER //
// ./src/common/hooks/UseFetchPaymentTerms.tsx